import { artBoardActions } from '@store/reducers/artboard'
import type React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import type { AppState } from '@/types'
import css from './Preview.module.scss'

const Preview: React.FC = () => {
  const dispatch = useDispatch()

  const preview = useSelector<AppState, string | null>(
    (state) => state.artboard.preview
  )

  const onClose = () => {
    dispatch(artBoardActions.setPreview(null))
  }

  if (!preview) {
    return null
  }

  return (
    <div className={css.container} onClick={onClose}>
      <div className={css.image}>
        <img src={preview.replace('.160.', '.')} alt="" />
      </div>
    </div>
  )
}

export default Preview
